<div class="action-wrapper">
  <ng-content></ng-content>
</div>
